import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutPageComponent } from './pages/layout.page/layout.page.component';
import { UnauthorizedPageComponent } from './pages/unauthorized.page/unauthorized.page.component';
import { ForbiddenPageComponent } from './pages/forbidden.page/forbidden.page.component';
import { UnavailableComponent } from './pages/unavailable/unavailable.component';
import { ContextResolverService } from '../shared/sharedServices/contextResolver.service';

const routes: Routes = [
  {
    path: '',
    component: LayoutPageComponent,
    resolve: {
      context: ContextResolverService,
    },
    children: [
      {
        path: 'acceso-denegado-servicio',
        component: UnauthorizedPageComponent,
      },
      {
        path: 'acceso-denegado-modulo',
        component: ForbiddenPageComponent,
      },
      {
        path: 'no-disponible',
        component: UnavailableComponent,
      },
    ],
  },
];

/**
 *  Router pass request to child components
 */

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
